// extracted by mini-css-extract-plugin
module.exports = {"formSection":"basicInformation_formSection__6-gCN","content":"basicInformation_content__2Ff6P","input":"basicInformation_input__NtqNb"};